import axios from 'axios'
import {
  getUserToken
} from './functions.js'
import {getServerApi} from './config/deployment'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

const envUri = getServerApi();
const noteUri = envUri+'/api/notes/booking';


export const getNotesForDeal = async (dealId, accountId) =>{
  const token = await getUserToken();
  const response = await axios.get(noteUri, {
        params: {
            bookingId: dealId,
            accountId,
            token,
            // userUid: userUid,
        },
    });

  return response.data.body || [];
};


export const uploadNote = (note, dealId, accountId) =>{
  return getUserToken()
    .then(res => {
      var user = getCurrentFirebaseUser()
      var uid = ''
      if (user) {
        uid = user.uid
      }

      const serverNote = {
        "id": note._id,
        'title': note.title,
        'body': note.body,
        'createdAt': note.createdAt,
        'updatedAt':note.updatedAt,
        'userUid': uid,
        'accountId': accountId,
        "archived": note.archived.toString(),
      };

      return axios.put(noteUri, {
          bookingId: dealId,
          note: serverNote,
          token: res,
      })
        .then(resp => {
          if(!note._id && resp.data.body._id) note._id = resp.data.body._id
          return note
        })
        .catch(err => {
          return err.toString
        })
    })
}



// WEBPACK FOOTER //
// ./src/dealNotesRepository.js